import {PartialRouting} from '../partial-routing';

export class RoutingRecoveryPassword extends PartialRouting {
    constructor(base: string = '') {
        super(base);
    }

    resetPassword(userId: number | string, token?: string): string {
        if (!token) {
            return `${this.base}${userId}`;
        }
        return `${this.base}${userId}?code=${token}`;
    }
}
